
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function SearchPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [plateNumber, setPlateNumber] = useState(searchParams.get('plate') || '');
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!plateNumber.trim()) return;
    
    setLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      navigate(`/results?plate=${encodeURIComponent(plateNumber)}`);
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20 font-cairo">
      <TopNavigation 
        title="البحث عن رقم اللوحة"
        showBack={true}
      />
      
      <div className="pt-16 px-6 py-8">
        {/* Search Form */}
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 mx-auto">
              <i className="ri-search-line text-2xl text-purple-600 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              البحث عن صاحب السيارة
            </h2>
            <p className="text-gray-600">
              أدخل رقم اللوحة للعثور على صاحب السيارة
            </p>
          </div>

          <div className="space-y-4">
            <Input
              label="رقم اللوحة"
              value={plateNumber}
              onChange={(e) => setPlateNumber(e.target.value)}
              placeholder="مثال: أ ب ج 1234"
              icon={<i className="ri-car-line w-5 h-5 flex items-center justify-center"></i>}
              className="text-center text-lg font-medium"
            />

            <Button
              onClick={handleSearch}
              className="w-full"
              size="lg"
              loading={loading}
              disabled={!plateNumber.trim()}
            >
              {loading ? 'جارٍ البحث...' : 'بحث'}
            </Button>
          </div>
        </div>

        {/* Alternative Options */}
        <div className="space-y-4">
          <div className="bg-white rounded-xl shadow-sm p-4">
            <button
              onClick={() => navigate('/camera')}
              className="w-full flex items-center justify-center space-x-3 space-x-reverse p-3 text-purple-600 hover:bg-purple-50 rounded-lg transition-colors"
            >
              <span className="font-medium">استخدم الكاميرا بدلاً من ذلك</span>
              <i className="ri-camera-line text-xl w-6 h-6 flex items-center justify-center"></i>
            </button>
          </div>

          {/* Search Tips */}
          <div className="bg-purple-50 rounded-xl p-4">
            <h3 className="font-semibold text-purple-900 mb-2 text-right">نصائح للبحث:</h3>
            <ul className="text-purple-800 text-sm space-y-1 text-right">
              <li>• تأكد من إدخال رقم اللوحة بشكل صحيح</li>
              <li>• استخدم المسافات بين الأحرف والأرقام</li>
              <li>• يمكنك استخدام الكاميرا للحصول على دقة أكبر</li>
            </ul>
          </div>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
